import {
  SET_HOME,
  SET_HOMES,
  CHANGE_NAME,
  CHANGE_ADDRESS,
  CHANGE_ADS_ADDRESS,
  CREATE_BEDROOM,
  SET_BEDROOM,
  DELETE_BEDROOM,
  ADD_BUSY_BED,
  DELETE_BUSY_BED,
  CHANGE_BATHROOMS_NUMBER,
  CHANGE_OTHERROOM,
  SET_IF_OWNER_IN_HOME,
  CHANGE_TENANTS,
  DELETE_TENANT,
  SET_ADVERTISE,
  SET_ADS,
  DELETE_ADVERTISE,
  CHANGE_SLOT,
  SET_SLOT,
  ADD_USER_IN_SLOT,
  CHANGE_SERVICE,
  SET_STEP_NUMBER,
  SET_NOTIFICATION,
  SET_NOTIFICATION_STATE,
  ADD_NOTIFICATION,
  READ_NOTIFICATION,
  ADD_PHOTO,
  ADD_PHOTO_LOADER,
  DELETE_PHOTO,
  CHANGE_PROFILE_IMAGE,
  CHANGE_PREFERENCES,
  CHANGE_DESCRIPTION,
  CHANGE_TYPE,
  CHANGE_SQUARE,
  ADD_INVITATION,
  CHANGE_WHATSAPP,
  CHANGE_MESSENGER,
  CHANGE_INSTAGRAM,
  CHANGE_TIKTOK,
  CHANGE_TELEGRAM,
  SET_NEW,
} from "@/constants/action-home-types";

import type {
  IHome,
  ICoordinate,
  ITenant,
  IAdvertise,
  ISlot,
  INotification,
  IImage,
  IMessengerContact,
  IWhatsappContact,
} from "@/types";

// Types for action payloads
interface AddressPayload {
  city: string;
  address: string;
  coordinates: ICoordinate;
}

interface BedroomCreatePayload {
  id: number;
  type: string;
}

interface BedroomSetPayload {
  n_beds: number;
  n_busy_beds: number;
  id: number;
}

interface OwnerInHomePayload {
  ownerInHome: boolean;
  ownerRoom: string;
}

interface SlotUserPayload {
  hour: number;
  minute: number;
  day: number;
  month: number;
  state: "accepted" | "refused" | "pending";
  id: string;
}

interface NotificationStatePayload {
  id: string;
  state: string;
}

interface TenantDeletePayload {
  tenant_id: number;
}

interface OtherRoom {
  exist: boolean;
  value: string;
}

interface Service {
  exist: boolean;
  value: string;
}

interface AdsAddressPayload {
  coordinates: ICoordinate;
  zone: string;
}

// Action creators
export const setHome = (home: IHome) =>
  ({ type: SET_HOME, payload: home } as const);
// The list of the user's properties (multi-home), summarized for the hub.
export const setHomes = (homes: any[]) =>
  ({ type: SET_HOMES, payload: homes } as const);
export const homeChangeName = (name: string) =>
  ({
    type: CHANGE_NAME,
    payload: name,
  } as const);

export const homeChangeAddress = (
  city: string,
  address: string,
  coordinates: ICoordinate
) =>
  ({
    type: CHANGE_ADDRESS,
    payload: { city, address, coordinates },
  } as const);

export const homeCreateBedroom = (id: number, type: string) =>
  ({
    type: CREATE_BEDROOM,
    payload: { id, type },
  } as const);

export const homeSetBedroom = (
  n_beds: number,
  n_busy_beds: number,
  id: number
) =>
  ({
    type: SET_BEDROOM,
    payload: { n_beds, n_busy_beds, id },
  } as const);

export const homeDeleteBedroom = (index: number) =>
  ({
    type: DELETE_BEDROOM,
    payload: index,
  } as const);

export const homeAddBusyBed = (index: number) =>
  ({
    type: ADD_BUSY_BED,
    payload: index,
  } as const);

export const homeDeleteBusyBed = (index: number) =>
  ({
    type: DELETE_BUSY_BED,
    payload: index,
  } as const);

export const homeChangeBathroomsNumber = (number: number) =>
  ({
    type: CHANGE_BATHROOMS_NUMBER,
    payload: number,
  } as const);

export const homeChangeOtherRooms = (other_rooms: OtherRoom[]) =>
  ({
    type: CHANGE_OTHERROOM,
    payload: other_rooms,
  } as const);

//export const homeChangeTenantsNumber = index => ({ type: CHANGE_TENANTS_NUMBER, payload: index });
export const homeSetIfOwnerInHome = (ownerInHome: boolean, ownerRoom: string) =>
  ({
    type: SET_IF_OWNER_IN_HOME,
    payload: { ownerInHome, ownerRoom },
  } as const);

export const homeChangeTenants = (bedrooms: ITenant[]) =>
  ({
    type: CHANGE_TENANTS,
    payload: bedrooms,
  } as const);

export const homeDeleteTenant = (tenant_id: number) =>
  ({
    type: DELETE_TENANT,
    payload: { tenant_id },
  } as const);
export const homeChangeSlots = (slots: ISlot[]) =>
  ({
    type: CHANGE_SLOT,
    payload: slots,
  } as const);

export const homeSetSlots = (slots: ISlot[]) =>
  ({
    type: SET_SLOT,
    payload: slots,
  } as const);

export const homeChangeServices = (services: Service[]) =>
  ({
    type: CHANGE_SERVICE,
    payload: services,
  } as const);

export const homeSetStepNumber = (i: number) =>
  ({
    type: SET_STEP_NUMBER,
    payload: i,
  } as const);

export const homeSetAds = (advertises: IAdvertise[]) =>
  ({
    type: SET_ADS,
    payload: advertises,
  } as const);

export const homeAddUserInSlot = (slot: SlotUserPayload) =>
  ({
    type: ADD_USER_IN_SLOT,
    payload: slot,
  } as const);

export const homeSetNotifications = (notifications: INotification[]) =>
  ({
    type: SET_NOTIFICATION,
    payload: notifications,
  } as const);

export const homeSetNotificationState = (id: string, state: string) =>
  ({
    type: SET_NOTIFICATION_STATE,
    payload: { id, state },
  } as const);

export const homeAddNotification = (notification: INotification) =>
  ({
    type: ADD_NOTIFICATION,
    payload: notification,
  } as const);

export const homeReadNotifications = () =>
  ({
    type: READ_NOTIFICATION,
    payload: {},
  } as const);

export const setAdvertise = (advertise: IAdvertise) =>
  ({
    type: SET_ADVERTISE,
    payload: advertise,
  } as const);

export const deleteAdvertise = (index: string) =>
  ({
    type: DELETE_ADVERTISE,
    payload: index,
  } as const);

export const homeChangeAdsAddress = (coordinates: ICoordinate, zone: string) =>
  ({
    type: CHANGE_ADS_ADDRESS,
    payload: { coordinates, zone },
  } as const);

export const homeAddPhoto = (photo: IImage) =>
  ({
    type: ADD_PHOTO,
    payload: photo,
  } as const);

export const homeAddPhotoLoader = (length: number) =>
  ({
    type: ADD_PHOTO_LOADER,
    payload: length,
  } as const);

export const homeDeletePhoto = (id: string) =>
  ({
    type: DELETE_PHOTO,
    payload: id,
  } as const);

export const homeChangeProfileImage = (photo: string) =>
  ({
    type: CHANGE_PROFILE_IMAGE,
    payload: photo,
  } as const);

export const homeChangePreferences = (preferences: string[]) =>
  ({
    type: CHANGE_PREFERENCES,
    payload: preferences,
  } as const);

export const homeChangeDescription = (description: string) =>
  ({
    type: CHANGE_DESCRIPTION,
    payload: description,
  } as const);

export const homeChangeType = (type: string) =>
  ({
    type: CHANGE_TYPE,
    payload: type,
  } as const);

export const homeChangeSquare = (square: number) =>
  ({
    type: CHANGE_SQUARE,
    payload: square,
  } as const);

export const homeAddInvitation = (ads_id: string, invitation_id: string) =>
  ({
    type: ADD_INVITATION,
    payload: { ads_id, invitation_id },
  } as const);

export const homeChangeWhatsapp = ({ prefix, number }: IWhatsappContact) =>
  ({
    type: CHANGE_WHATSAPP,
    payload: { prefix, number },
  } as const);

export const homeChangeMessenger = ({
  name,
  link,
}: {
  name: string;
  link: string;
}) =>
  ({
    type: CHANGE_MESSENGER,
    payload: { name, link },
  } as const);

export const homeChangeInstagram = (contact: string) =>
  ({
    type: CHANGE_INSTAGRAM,
    payload: contact,
  } as const);

export const homeChangeTiktok = (contact: string) =>
  ({
    type: CHANGE_TIKTOK,
    payload: contact,
  } as const);

export const homeChangeTelegram = (contact: string) =>
  ({
    type: CHANGE_TELEGRAM,
    payload: contact,
  } as const);

export const homeSetNew = (newHome: boolean) =>
  ({
    type: SET_NEW,
    payload: newHome,
  } as const);
